import React from 'react';
import { connect } from 'react-redux';
import AsyncSelect from "react-select/async";
import axios from 'axios';
import ErrorValidation from '../../../services/ErrorValidation';
import Ax from '../../../components/hoc/Ax';
import ReactSelectStyle from '../../../components/ui/ReactSelectStyle';
import { IAM_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import api from '../../../services/api';

class InputExpenseSearch extends React.Component {
    
    constructor(props) {
        super(props);
        this.state = {
            selectedEmployee: null,
            timer: false,
            defaultOptions: [],
            isLoading: false
        };
        this.cancelToken = null;
        this.apiTimeout = null;
        this.emp_list_url = IAM_API_BASE_URL_2 + '/expense/listing';
    }
    
    initParams = (props) => {
       
        
        this.setState(() => {
            if(this.props.loadDefaultOptions && !this.props.linkedEmployee) {
                this.getDefaultOptions();
            }
            if(this.props.loadDefaultOptions && this.props.linkedEmployee && this.props.linkedEmployee.length > 0) {
                this.setState({
                    defaultOptions: this.formatExpenseOptions(this.props.linkedEmployee)
                });
            }
        });
    }
    
    componentDidMount() {
        this.initParams(this.props);
    }

    componentWillUnmount() {
        if (this.cancelToken) {
            this.cancelToken.cancel("Component unmounted");
        }
        clearTimeout(this.apiTimeout);
    }

    onInputChange = (selectedOption) => {
        this.props.changeEvent(selectedOption);
    }
    
    formatExpenseOptions = (expenses) => {
        return expenses.map(expense => ({
            label: `${expense.transaction_id} - ${expense.employee?.fname || ''} ${expense.employee?.lname || ''} (${expense.amount})`,
            value: expense.enc_id || expense.id,
            expense: expense,
            transaction_id: expense.transaction_id,
            amount: expense.amount,
            expense_date: expense.expense_date,
        }));
    };
    
    loadingOptions = (inputText, callback) => {
        if(inputText.length > 2) {
            clearTimeout(this.apiTimeout);
            
            if (this.cancelToken) {
                this.cancelToken.cancel("Operation canceled due to new request.");
            }
            this.cancelToken = axios.CancelToken.source();

            const params = {
                search_by_text: inputText,
                search_vendor_id: this.props.search_vendor_id || "",
            };

            this.setState({ isLoading: true });
            
            this.apiTimeout = setTimeout(() => {
                this.getLoadingOptions(params, callback);
            }, 500); 
        } else {
            callback([]);
        }
    }

    getLoadingOptions = (params, callback) => {
        api.server2Api({
            method: 'GET',
            headers: { 'Authorization': 'Bearer ' + this.props.access_token },
            params: params,
            url: this.emp_list_url,
            cancelToken: this.cancelToken.token
        })
        .then((response) => {
            this.setState({ isLoading: false });
            const formattedOptions = this.formatExpenseOptions(response.data?.expenses?.data);
            callback(formattedOptions);
        })
        .catch((err) => {
            this.setState({ isLoading: false });
            if (axios.isCancel(err)) {
                console.log('Request canceled:', err.message);
            } else {
                ErrorValidation.apiErrorHandle(err, 'Unable to fetch expense data.');
                callback([]);
            }
        });
    }

    getDefaultOptions = () => {
        this.setState({ defaultOptions: [], isLoading: true });
        
        api.server2Api({
            method: 'GET',
            headers: { 'Authorization': 'Bearer ' + this.props.access_token },
            params: this.state.params,
            url: this.emp_list_url
        })
        .then((response) => {
            this.setState({
                defaultOptions: this.formatExpenseOptions(response.data.data),
                isLoading: false
            });
        })
        .catch((err) => {
            this.setState({ isLoading: false });
            if (axios.isCancel(err)) {
                console.log('Request canceled:', err.message);
            } else {
                ErrorValidation.apiErrorHandle(err, 'Unable to fetch expense data.');
            }
        });
    }

    clearSelection = () => {
        this.onInputChange(null);
    }

    getSelectedExpense = () => {
        return this.props.value?.expense || null;
    }
    
    render() {
        const { isLoading } = this.state;
        const { value, isMulti, disabled, required, placeholder, menuPlacement, loadDefaultOptions } = this.props;

        return (
            <Ax>
                <AsyncSelect
                    styles={ReactSelectStyle(this.props)}
                    menuPlacement={menuPlacement || "bottom"}
                    placeholder={placeholder || "Search Expense by Transaction ID or Employee"}
                    loadingMessage={() => isLoading ? 'Loading...' : 'Searching...'}
                    noOptionsMessage={(input) => {
                        if(input.inputValue.length === 0) {
                            return 'Please enter 3 or more characters';
                        } else if (input.inputValue.length < 3) {
                            return 'Please enter 3 or more characters';
                        } else {
                            return 'No expenses found';
                        }
                    }}
                    minimumInput={3}
                    onChange={this.onInputChange}
                    isClearable={true}
                    loadOptions={this.loadingOptions}
                    value={value}
                    isMulti={isMulti || false}
                    isDisabled={disabled || false}
                    defaultOptions={loadDefaultOptions ? this.state.defaultOptions : null}
                    cacheOptions={true}
                    className="expense-search-select"
                    classNamePrefix="expense-select"
                />
                <input
                    name='expense_search'
                    tabIndex={-1}
                    required={required || false}
                    value={isMulti ? 
                        (value && value.length > 0 ? value.map(v => v.label).join(', ') : '') : 
                        (value ? value.label : '')
                    }
                    onChange={() => {}}
                    style={{
                        opacity: 0,
                        width: 0,
                        height: 0,
                        padding: 0,
                        margin: 0,
                        display: 'table'
                    }}
                />
            </Ax>
        );
    }
}

const mapStateToProps = state => {
    return {
        access_token: state.auth.access_token
    };
};

export default connect(mapStateToProps)(InputExpenseSearch);